import React from 'react';
import userDefaultImage from '../../../../../assets//svg/user-default-icon.svg';
import './anMentorInfoComponent.css';

const AnMentorInfoComponent = ({
  displayName = '',
  sessionTitle = '',
  userProfileImage = '',
}) => {
  return (
    <div className="et-an-mic-mentor-info-wrap">
      <img
        className="et-an-mic-mentor-profile-img"
        src={userProfileImage || userDefaultImage}
        alt=""
      />
      <div className="et-an-mic-mentor-name-session-title-wrap">
        <div className="et-an-mic-mentor-name-txt">{displayName}</div>
        <div className="et-an-mic-session-title-txt">{sessionTitle}</div>
      </div>
    </div>
  );
};

export default AnMentorInfoComponent;
